import {combineReducers} from 'redux'
import * as actions from './actions'
import * as actionTypes from './actionTypes'
import {IState, ISubject} from './model'
import {reducer as treatmentReportReducer} from './treatmentReport'

type ItemsState = ISubject[]
const itemsInitialState: ItemsState = []
type ItemsAction =
  actions.IActionSetSubjects
  | actions.IActionClearSubjects

const itemsReducer = (state: ItemsState = itemsInitialState, action: ItemsAction): ItemsState => {
  switch (action.type) {
    case actionTypes.SET_SUBJECTS:
      return action.payload
    case actionTypes.CLEAR_SUBJECTS:
      return []
    default:
      return state
  }
}

type IsFetchingState = boolean
const isFetchingInitialState = false
type IsFetchingAction =
  actions.IActionSetIsFetching
  | actions.IActionResetIsFetchingSubjects

const isFetchingReducer = (
  state: IsFetchingState = isFetchingInitialState,
  action: IsFetchingAction,
): IsFetchingState => {
  switch (action.type) {
    case actionTypes.SET_IS_FETCHING_SUBJECTS:
      return true
    case actionTypes.RESET_IS_FETCHING_SUBJECTS:
      return false
    default:
      return state
  }
}

type IsConfirmActiveState = boolean
const isConfirmActiveInitialState = false
type IsConfirmActiveAction =
  actions.IActionSetIsConfirmActive
  | actions.IActionResetIsSubjectActivationConfirmActive

const isConfirmActiveReducer = (
  state: IsConfirmActiveState = isConfirmActiveInitialState,
  action: IsConfirmActiveAction,
): IsConfirmActiveState => {
  switch (action.type) {
    case actionTypes.SET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE:
      return true
    case actionTypes.RESET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE:
      return false
    default:
      return state
  }
}

const reducer = combineReducers<IState>({
  items: itemsReducer,
  isFetching: isFetchingReducer,
  isConfirmActive: isConfirmActiveReducer,
  treatmentReport: treatmentReportReducer,
})

export default reducer



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/subjects/reducer.ts